export default "__VITE_ASSET__DgdbzIW1__"